const Config = {
	BASEURL: process.env.REACT_APP_BASEURL,
	ASSETSPATH: process.env.REACT_APP_ASSETSPATH,
	STORAGEPATH: process.env.REACT_APP_STORAGEPATH,
	APIURL: process.env.REACT_APP_APIURL,
	GTM_TAG: process.env.REACT_APP_GTM_TAG,
	PIXELID: 942234445902858,
	STATICFILEVERSION: process.env.REACT_APP_STATICFILESVERSION,
	WEBSITEURL: process.env.REACT_APP_WEBSITEBASEURL,
	PAYTMURL: process.env.REACT_APP_PAYTM_URL,
	STRIPEURL: process.env.REACT_APP_STRIPE_URL,
	GOOGLEAPI: process.env.REACT_APP_GOOGLE_API,
	RP_ORGID: process.env.REACT_APP_RP_ORG_ID,
	RP_JWT_SECRET: process.env.REACT_APP_RP_JWT_SECRET,
};

module.exports = Config;
